/* 🤖 this file was generated by svg-to-ts */
export const matIconBrightnessAuto: {
  name: 'brightness-auto';
  data: string;
} = {
  name: 'brightness-auto',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m11 7-3.2 9h1.9l.7-2h3.2l.7 2h1.9L13 7h-2zm-.15 5.65L12 9l1.15 3.65h-2.3zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48z"/></svg>`
};
